import { cn } from '@/ui/lib/utils'

export interface QuantLiveBadgeProps {
  /** Any wire string; an unknown value renders neutrally with its own text. */
  status: string
  className?: string
}

const STATUS_CLASS: Record<string, string> = {
  running: 'border-accent-line bg-accent-line text-ink',
  starting: 'border-accent-line bg-transparent text-accent-line',
  stalled: 'border-[#CB8A00] bg-[#CB8A00] text-ink',
  stopping: 'border-[#CB8A00] bg-transparent text-[#CB8A00]',
  stopped: 'border-paper-35 bg-transparent text-paper-90',
  interrupted: 'border-dashed border-[#CB8A00] bg-transparent text-[#CB8A00]',
  failed: 'border-alert bg-alert text-paper',
}
const UNKNOWN_CLASS = 'border-paper-35 bg-transparent text-paper-50'

/**
 * A live session's status badge (spec 041): the same 9px mono bold caps family
 * as `QuantRunBadge`, in a fixed 90 px box (measured: the widest word, `interrupted`, needs 89.25 px) so the eleven-letter `interrupted` and the
 * short `failed` take the same room. One treatment per known status.
 */
export function QuantLiveBadge({ status, className }: QuantLiveBadgeProps) {
  return (
    <span
      data-live-status={status}
      title={status}
      className={cn(
        'box-border inline-block w-[90px] min-w-[90px] max-w-[90px] shrink-0 truncate border px-1.5 py-0.5 text-center align-middle font-mono text-[9px] leading-[1.3] font-bold tracking-[0.16em] uppercase',
        Object.hasOwn(STATUS_CLASS, status) ? STATUS_CLASS[status] : UNKNOWN_CLASS,
        className,
      )}
    >
      {status}
    </span>
  )
}
